import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useRewardsUIContext } from "./RewardsUIContext";

const prepareFilter = (queryParams, values) => {
  const { searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  filter.name = searchText;
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function RewardsFilter() {
  // Rewards UI Context
  const rewardsUIContext = useRewardsUIContext();
  const rewardsUIProps = useMemo(() => {
    return {
      setQueryParams: rewardsUIContext.setQueryParams,
      openNewRewardDialog: rewardsUIContext.openNewRewardDialog,
      queryParams: rewardsUIContext.queryParams,
    };
  }, [rewardsUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(rewardsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, rewardsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      rewardsUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <div className="form-filtration">
        <div className="row align-items-center">
          <div className="col-md-2 margin-bottom-10-mobile">
            <Formik
              initialValues={{
                searchText: "",
              }}
              onSubmit={(values) => {
                applyFilter(values);
              }}
            >
              {({
                values,
                handleSubmit,
                handleBlur,
                handleChange,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div>
                    <input
                      type="text"
                      className="form-control"
                      name="searchText"
                      placeholder="Search"
                      onBlur={handleBlur}
                      value={values.searchText}
                      onChange={(e) => {
                        setFieldValue("searchText", e.target.value);
                        handleSubmit();
                      }}
                    />
                    <small className="form-text text-muted">
                      <b>Search</b> by Reward Name
                    </small>
                  </div>
                </form>
              )}
            </Formik>
          </div>
          <div className="col-md-8 margin-bottom-10-mobile"></div>
          <div className="col-md-2 text-right margin-bottom-10-mobile">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => rewardsUIProps.openNewRewardDialog()}
            >
              Create new reward
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
